import { FC, ReactElement, useEffect } from 'react'
import { NavLink, useNavigate } from 'react-router'

import { LoadingSpinner, MaterialIcon, ZeroState } from '@/components'
import { PlanningPreferenceItem } from '@/compositions'
import { ConnectedDateNavigator } from '@/connectors'
import { transformLegacyPayrollPeriodToPayrollPeriod } from '@/entities/PayrollPeriod/PayrollPeriodTransformers'
import { trans } from '@/helpers/trans'
import { setTimePeriodAndSelectedDays } from '@/redux/@interface/calendar/calendarActions'
import { getPreferenceDays } from '@/redux/preferences/preferenceActions'
import { useTypedDispatch, useTypedSelector } from '@/redux/store'
import { TimeModeType } from '@/types'

import './PlanningPreferencesPage.scss'

export const PlanningPreferencesPage: FC = (): ReactElement => {
    const dispatch = useTypedDispatch()
    const navigate = useNavigate()
    const { payrollPeriods } = useTypedSelector(state => state.appReducer)
    const { planningPreferences, loading } = useTypedSelector(state => state.preferenceReducer)
    const { selectedDays, timeMode } = useTypedSelector(state => state.calendarReducer)

    const fetchPreferenceDays = (): void => {
        dispatch(getPreferenceDays())
    }

    useEffect(() => {
        if (timeMode !== TimeModeType.week) {
            dispatch(setTimePeriodAndSelectedDays(
                TimeModeType.week,
                selectedDays[0],
                payrollPeriods.map(transformLegacyPayrollPeriodToPayrollPeriod),
            ))
        }

        fetchPreferenceDays()
    }, [])

    const handlePlanningPreferenceClick = (id: string): void => {
        navigate(`/${trans('nav.planningPreferences.link')}/${id}`)
    }

    return (
        <>
            <ConnectedDateNavigator
                timeModeButtons={[TimeModeType.week]}
                onAfterDateChange={fetchPreferenceDays}
            />
            <div className="preferences__row">
                <div className="preferences__col">
                    <ul>
                        {planningPreferences.length > 0 ? planningPreferences.map(preference => (
                            <PlanningPreferenceItem
                                key={preference.id}
                                preference={preference}
                                onClick={() => handlePlanningPreferenceClick(preference.id)}
                                className="preferences__list-item"
                            />
                        )) : <ZeroState text={trans('pages.planningPreferences.emptyList')} />}
                    </ul>
                </div>
            </div>
            <NavLink
                className="btn-circle preferences__button-create-absences"
                to={`/${trans('nav.planningPreferences.link')}/${trans('nav.planningPreferences.createPlanningPreference.link')}`}
            >
                <MaterialIcon kind="add" color="white" fontSize={26} />
            </NavLink>
            {loading && <LoadingSpinner />}
        </>
    )
}
